import { Injectable } from '@angular/core';
import {returnFound } from 'find-and';

interface ReportEntry {
  options: {
    series: any[];
    servicely: {
      rsid: string;
    }
  };
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  reportCache: { [key: string]: ReportEntry } = {};

  constructor() { }

  addReport(key: string, report: any) {
    this.reportCache[key] = report;
  }

  removeReport(key: string) {
    delete this.reportCache[key];
  }

  getDrillDownIds(rsid: string, ddid: string): string[] {

    let result = [];
    const report = Object.keys(this.reportCache).find((k) => {
      const reportEntry = this.reportCache[k];
      return reportEntry.options.servicely.rsid === rsid;
    });

    if (report) {
      const reportEntry = this.reportCache[report];
      const ddEntry = returnFound(reportEntry.options.series, { rsid: rsid, ddid: ddid});
      if (ddEntry) {
        result = ddEntry.ddids;
      }
    }

    return result;
  }
}
